export interface AulaId {
  value: string;
}

export interface AulaInstructor {
  value: string;
}

export interface AulaDay {
  value: string;
}

export interface AulaUrl {
  value: string;
}

export interface AulaInstagram {
  value: string;
}

export class Aula {
  constructor(
    private readonly _id: AulaId,
    private readonly _instructor: AulaInstructor,
    private readonly _day: AulaDay,
    private readonly _url: AulaUrl,
    private readonly _instagram: AulaInstagram
  ) {}

  get id(): AulaId {
    return this._id;
  }

  get instructor(): AulaInstructor {
    return this._instructor;
  }

  get day(): AulaDay {
    return this._day;
  }

  get url(): AulaUrl {
    return this._url;
  }

  get instagram(): AulaInstagram {
    return this._instagram;
  }
} 